import { A } from "hookrouter";
import React from "react";
import { useState } from "react";
import ProductionUserService from "services/production/ProductionUserService";

const Login: React.FC = () => {
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");

    return (

        <div className="col-sm-6 trm-login">
            <div className="box">
                <div className="box-body">
                    <h2>Portal Login</h2>
                    <br />
                    {
                        errorMessage &&
                        <div>{errorMessage}<br /><br /></div>
                    }
                    <div className="form-group">
                        <label>Email Address</label>
                        <input type="text" className="form-control" placeholder="Email Address" onChange={(event) => { setEmailAddress(event.currentTarget.value); }} />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input type="password" className="form-control" placeholder="Password" onChange={(event) => { setPassword(event.currentTarget.value); }} />
                    </div>
                    <br />
                    <div className="form-group">
                        <button className="btn btn-primary" onClick={async () => {
                            if (emailAddress !== "" && password !== "") {
                                if (await new ProductionUserService().loginAsync(
                                    emailAddress,
                                    password)) {
                                    window.location.href = '/secure';
                                }
                                else {
                                    setErrorMessage("Invalid login");
                                }
                            }
                            else {
                                setErrorMessage("Both email address and password are required");
                            }
                        }}>Submit</button>
                    </div>
                    <div>
                        <A className="forgot-link" href="/" onClick={async () => {
                            if (emailAddress !== "") {
                                const result = await new ProductionUserService().passwordResetAsync(
                                    emailAddress);

                                if (result) {
                                    setErrorMessage("Password reset request submitted!!");
                                }
                                else {
                                    setErrorMessage("Account not found!!");
                                }
                            }
                            else {
                                setErrorMessage("To reset your password, please enter your email address. We will send the password reset instructions to the email address for this account.");
                            }
                        }}>Forgot Password</A>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;